export const WIX_TIPS_APP_DEF_ID = '869a50c8-dd38-4324-b201-e33dc0747a5f';
